import { PapiDeviation } from '@wix/da-papi-types';

export enum BackgroundType {
  NONE = 'none',
  SOLID = 'solid',
  GRADIENT = 'gradient',
  PATTERN = 'pattern',
  IMAGE = 'image',
}

export enum BackgroundImageDisplayMode {
  TILE = 'tile',
  COVER = 'cover',
  CONTAIN = 'contain',
}

export type BackgroundVariant = 'custombox' | 'status' | 'hero';

export type BackgroundInfo = {
  color?: string;
  fontColor?: string;
  linkColor?: string;
  linkHoverColor?: string;
  gradient?: number;
  pattern?: string;
  backgroundType?: BackgroundType;
  imageDisplayMode?: BackgroundImageDisplayMode;
  imageDeviation?: PapiDeviation;
  imageUrl?: string;
  imageTint?: string;
};
